module.exports = __webpack_public_path__ + "img/Burundi.460bf4c1.png";